import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '../icons';

export const SearchPagination = ({
  page,
  hasPreviousPage,
  hasNextPage,
  onPreviousPage,
  onNextPage,
  paginationButtonBgColor
}) => {
  if (!hasPreviousPage && !hasNextPage) {
    return null;
  }

  const defaultBg = '#712cf9';
  const bgColor = paginationButtonBgColor || defaultBg;

  return (
    <div className="vo-search-pagination-container">
      <button
        className="vo-search-pagination-button"
        onClick={onPreviousPage}
        style={{
          backgroundColor: bgColor,
          opacity: hasPreviousPage ? 1 : 0.25,
          cursor: hasPreviousPage ? 'pointer' : 'not-allowed'
        }}
        disabled={!hasPreviousPage}
        aria-label="Previous page"
      >
        <ChevronLeftIcon size={20} />
      </button>

      <span className="vo-search-pagination-info">
        {page}
      </span>

      <button
        className="vo-search-pagination-button"
        onClick={onNextPage}
        style={{
          backgroundColor: bgColor,
          opacity: hasNextPage ? 1 : 0.25,
          cursor: hasNextPage ? 'pointer' : 'not-allowed'
        }}
        disabled={!hasNextPage}
        aria-label="Next page"
      >
        <ChevronRightIcon size={20} />
      </button>
    </div>
  );
};